import { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { formatNumberWithDot } from '../../helpers/conversions';

function TooltipProductInfo({ dataInfo, productIndex }) {
    const iconRef = useRef(null);
    const tooltipRef = useRef(null);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const [visible, setVisible] = useState(false);

    const showTooltip = (e) => {
        setVisible(true);

        requestAnimationFrame(() => {
            if (tooltipRef.current) {

                const tooltipWidth = tooltipRef.current.offsetWidth;
                const tooltipHeight = tooltipRef.current.offsetHeight;

                const totalItems = dataInfo.length;
                const itemsPerColumn = 25;
                const numColumns = Math.ceil(totalItems / itemsPerColumn);
                const tooltipOffset = totalItems > 25 || numColumns > 1 ? 200 : 0;

                const openLeft = (productIndex + 1) % 4 === 0 || (productIndex + 1) % 4 === 3;

                setCoords({
                    top: e.clientY + window.scrollY - tooltipHeight + tooltipOffset,
                    left: openLeft
                        ? e.clientX + window.scrollX - tooltipWidth
                        : e.clientX + window.scrollX,
                });
            }
        });
    };

    const hideTooltip = () => setVisible(false);

    useEffect(() => {
        const handleScroll = () => setVisible(false);
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, []);

    const itemsPerColumn = 25;
    const numColumns = Math.ceil(dataInfo.length / itemsPerColumn);
    const columns = [];
    for (let i = 0; i < dataInfo.length; i += itemsPerColumn) {
        columns.push(dataInfo.slice(i, i + itemsPerColumn));
    }

    return (
        <>
            <span
                className="tooltip-icon"
                ref={iconRef}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
            >
                ℹ
            </span>
            {visible &&
                createPortal(
                    <div
                        className="tooltip-box-fixed"
                        ref={tooltipRef}
                        style={{
                            position: 'absolute',
                            top: `${coords.top}px`,
                            left: `${coords.left}px`,
                            zIndex: 9999,
                            display: 'grid',
                            gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))`,
                            columnGap: '20px',
                        }}
                    >
                        {columns.map((column, colIdx) => (
                            <div key={colIdx} className="tooltip-column">
                                {column.map((item, idx) => (
                                    <div key={idx} className="tooltip-item">
                                        <span>{item?.color?.name}: </span>
                                        <span>{ formatNumberWithDot(item.stock)} unid.</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>,
                    document.body
                )}
        </>
    );
}

export default TooltipProductInfo;
